import { useFirestore } from "../../../firebase/useFirestore";
import ToggleButton from "../../common/ToggleButton";

const AdjustStatusInTaskEditor = () => {
    const compagny = useFirestore("CompagnyMeta");

    return (
        <div className="dashboard-container">
            <h2>Status huishouden aanpassen</h2>
            <p>
                Zet aan om de status van een huishouden aan te kunnen passen vanuit een taak (huisbezoek).
            </p>
            {compagny && compagny.map((comp) => (
                <div key={comp.ID} className="settings-general-module-settings-item-container">
                    <p>Aanpassen vanuit taak</p>
                    <ToggleButton
                        docid={comp.docid}
                        id={"AdjustStatusInTaskEditor"}
                        collection={"CompagnyMeta"}
                        value={comp.AdjustStatusInTaskEditor}
                    />
                </div>
            ))}
        </div>
    );
};

export default AdjustStatusInTaskEditor;
